import gql from 'graphql-tag'

export const GET_WIDGETS_AND_LABS_LIST = gql`
  query getLabsList {
    coordinator {
      labs {
        list {
          id
          name
        }
      }
      dashboardWidget {
        list {
          widget
          allowed
        }
      }
    }
  }
`
